import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    $(this.element).on('select2:select', this.onChange.bind(this));

    this.onChange();
  }

  onChange() {
    let selectedOption = this.element.selectedOptions[0];
    document.querySelectorAll('.select2-collapse-target').forEach((el) => {
      el.classList.toggle('hidden', true);
      el.classList.toggle('block', false);
    });

    try {
      document.querySelectorAll(selectedOption.dataset.collapseTarget).forEach((el) => {
        el.classList.toggle('hidden', false);
        el.classList.toggle('block', true);
      });
    } catch (ex) {}
  }

  disconnect() {
    $(this.element).select2('destroy');
  }
};